/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Infos'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeInfosLuggage from '../../../components/infos/luggage/Home.vue'; // lugagge
import HomeInfosImportantInfos from '../../../components/infos/important-infos/Home.vue'; // covid => important-infos
import HomeInfosDangerousGoods from '../../../components/infos/dangerous-goods/Home.vue'; // dangerous-goods
import HomeInfosProhibitedItems from '../../../components/infos/prohibited-items/Home.vue'; // prohibited-items
import HomeInfosAdditionalServices from '../../../components/infos/additional-services/Home.vue'; // additional-services
import HomeInfosServiceOnBoard from '../../../components/infos/serviceonboard/Home.vue'; // serviceonboard
import HomeInfosSeatReservation from '../../../components/infos/seat-reservation/Home.vue'; // seat-reservation
import HomeInfosFareConditions from '../../../components/infos/fare-conditions/Home.vue'; // fare-conditions
// import HomeInfosComplaints from '../../../components/infos/complaints/Home.vue'; // complaints
import HomeInfosGroupBooking from '../../../components/infos/group-booking/Home.vue'; // group-booking
import HomeInfosInfoAlertBooking from '../../../components/infos/infoalert/Home.vue'; // infoalert (Ticket:APP)
import HomeInfosDataProtectionBooking from '../../../components/infos/dataprotection/Home.vue'; // data protection (Bast Wish)
import HomeInfosInfo3gBooking from '../../../components/infos/info3g/Home.vue'; // infoalert (Ticket:APP)

export const routesinfos = [
    { path: '/luggage', component: HomeInfosLuggage },
    { path: '/important-infos', component: HomeInfosImportantInfos },
    { path: '/dangerous-goods', component: HomeInfosDangerousGoods },
    { path: '/prohibited-items', component: HomeInfosProhibitedItems },
    { path: '/additional-services', component: HomeInfosAdditionalServices },
    { path: '/serviceonboard', component: HomeInfosServiceOnBoard },
    { path: '/seat-reservation', component: HomeInfosSeatReservation },
    { path: '/fare-conditions', component: HomeInfosFareConditions },
    // { path: '/complaints', component: HomeInfosComplaints },
    { path: '/group-booking', component: HomeInfosGroupBooking },
    { path: '/infoalert', component: HomeInfosInfoAlertBooking },
    { path: '/dataprotection', component: HomeInfosDataProtectionBooking },
    { path: '/info3g', component: HomeInfosInfo3gBooking },

];



// WEBPACK FOOTER //
// ./src/routes/modules/infos/routes.js